import React from 'react'
import styled from 'styled-components'
import ServiceRequestListContainer from '../../containers/Dashboard/ServiceRequests/ServiceRequestListContainer'
import Header from '../../components/Header/Header'
import Clock from '../../components/Clock/Clock'
import HeaderButton from '../../components/Header/HeaderButton'
import {useUIDispatch} from '../../context/UIContext'
import {_L, useLocaleState} from '../../context/LocaleContext'
import {isServiceCatalog} from '../../utils/routing'

const ServiceRequestList = () => {
  const uiDispatch = useUIDispatch()
  const localeState = useLocaleState()
  const isCatalog = isServiceCatalog()

  const onCancel = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: isCatalog ? 'SERVICE_CATALOG' : 'DASHBOARD'}
    })

  return (
    <Container>
      <Header
        leftContent={<Clock />}
        rightContent={
          <HeaderButton
            label={_L({key: 'Cancel', localeState})}
            onClick={onCancel}
          />
        }
      />
      <ListContainer>
        <ServiceRequestListContainer />
      </ListContainer>
    </Container>
  )
}

export default ServiceRequestList

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #eff0f3;
  box-sizing: border-box;
`

const ListContainer = styled.div`
  display: flex;
  justify-content: center;
  height: calc(100vh - 80px);
  padding: 24px 24px 24px 24px;
  overflow: visible;
  @media (max-width: 420px) {
    padding: 0;
  }
`
